import React from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

/**
 * A common way to show a full screen error message when an unexpected problem occurs. Injects showError() to any
 * component it wraps.
 */
export default function(Component) {
  class ErrorWrapper extends React.Component {
    constructor(props) {
      super(props);

      this.state = {};
    }

    render() {
      const { message, opened } = this.state;
      const msg = message || "There was a problem in processing your last request, please try again later.";

      return (
        <div>
          <Modal open={opened} basic size="small" className="semantic-ui">
            <Header color="red">
              <Icon name="warning sign" />
              Unexpected Error
            </Header>
            <Modal.Content>
              <p className="ui center aligned grid">{msg}</p>
            </Modal.Content>
            <Modal.Actions className="ui center aligned grid">
              <Button
                basic
                inverted
                onClick={() => {
                  this.setState({ opened: false });
                }}
              >
                Close
              </Button>
            </Modal.Actions>
          </Modal>

          <Component
            {...this.props}
            showError={error => {
              let errorMessage;

              // support for a handful of error formats.
              if (typeof error === "object") {
                if (typeof error.message !== "undefined") {
                  if (typeof error.message === "object") {
                    errorMessage = Object.keys(error.message)
                      .map(key => `${key}: ${error.message[key]}`)
                      .join(", ");
                  } else {
                    errorMessage = error.message;
                  }
                } else if (typeof error.errorMessage !== "undefined") {
                  errorMessage = error.errorMessage;
                } else if (typeof error.errors !== "undefined") {
                  // This is the v1 error format when there are form errors
                  const allErrors = [];
                  Object.keys(error.errors).forEach(prop => {
                    const errors = error.errors[prop];
                    allErrors.push(`${prop}: ${errors.join(", ")}.`);
                  });
                  errorMessage = allErrors.join(" ");
                } else {
                  throw Error("Unexpected error object");
                }
              } else {
                errorMessage = error;
              }

              this.setState({ opened: true, message: errorMessage });
            }}
          />
        </div>
      );
    }
  }

  return ErrorWrapper;
}
